import build1 from "../assets/build1.jpg";
import build2 from "../assets/build2.jpg";
import build3 from "../assets/build3.jpg";
import build4 from "../assets/build4.jpg";
import build5 from "../assets/build5.jpg";
import build6 from "../assets/build6.jpg";
import build7 from "../assets/build7.jpg";
import build8 from "../assets/build8.jpg";

export const buildGallery = [
  { src: build1, alt: "Pc tower with red rgb light" },
  { src: build2, alt: "Pc tower with rainbow rgb light" },
  { src: build3, alt: "Pc tower with green rgb light" },
  { src: build4, alt: "Pc tower with purple rgb light" },
  { src: build5, alt: "Pc tower with light pink rgb light" },
  { src: build6, alt: "Pc tower with dark blue rgb light" },
  { src: build7, alt: "Pc tower with purple and pink rgb light" },
  { src: build8, alt: "Pc tower with light blue rgb light" },
];
